module.exports = __webpack_public_path__ + "static/media/RIO-GRANDE_MainFloor-Layout.00d50879.jpg";